import { useAccountContext } from '@gonfalon/app-context/useAccountContext';
import { isReader } from '@gonfalon/members/isReader';
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { toCreateFlag, toFlags } from '@gonfalon/navigator/navigators';
import { Restrict } from '@gonfalon/permissions/restrict';
import { Link, LinkButton } from '@launchpad-ui/components';

import { Jumbo } from '#components/Jumbo';

type FlagNotFoundProps = {
  projKey: string;
  envKey: string | undefined;
};

export function FlagNotFound({ projKey, envKey }: FlagNotFoundProps) {
  const { profile } = useAccountContext();
  const isReader_ = isReader(profile);
  const action = (
    <Restrict willHide isRestricted={isReader_}>
      <>
        {envKey && (
          <>
            <LinkButton variant="primary" href={toCreateFlag({ projectKey: projKey, environmentKey: envKey })}>
              {msg('flags.notFound.createFlag')}
            </LinkButton>{' '}
            <Message id="flags.notFound.orGoPrefix" />{' '}
          </>
        )}
        <Link href={toFlags({ projectKey: projKey })}>
          <Message id="flags.notFound.backToDashboard" />
        </Link>
      </>
    </Restrict>
  );

  return <Jumbo title={msg('flags.notFound.heading')} lead={msg('flags.notFound.body')} actions={action} isError />;
}
